import React from 'react';

const plans = [
  {
    name: 'Starter',
    price: '$9',
    features: [
      'Send 10 attendance reports',
      'Connect up to 2 classes',
      'Track up to 15 students per month',
      'Manual attendance support',
      'Export up to 3 reports',
    ],
    highlight: false,
  },
  {
    name: 'Small business',
    price: '$15',
    features: [
      'Send 25 attendance reports',
      'Connect up to 5 classes',
      'Track up to 50 students per month',
      'Automated attendance support',
      'Export up to 12 reports',
      'Bulk reconcile attendance',
      'Track in multiple groups',
    ],
    highlight: true,
  },
  {
    name: 'Enterprise',
    price: '$39',
    features: [
      'Send unlimited attendance reports',
      'Connect up to 15 classes',
      'Track up to 200 students per month',
      'Automated attendance support',
      'Export up to 25 reports',
    ],
    highlight: false,
  },
];

export default function PricingSection() {
  return (
    <section id="pricing" className="bg-gray-900 text-white py-16 px-4 text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-2">Simple pricing, for everyone.</h2>
      <p className="mb-10 text-gray-400">It doesn't matter what size your school is, our software will work well for you.</p>
      <div className="flex flex-col md:flex-row gap-8 justify-center items-center max-w-5xl mx-auto">
        {plans.map((plan) => (
          <div key={plan.name} className={`flex-1 max-w-xs rounded-2xl p-8 shadow-lg border border-gray-700 ${plan.highlight ? 'bg-blue-600 text-white scale-105 z-10' : 'bg-gray-800 text-gray-100'} transition-all`}>
            <div className="text-4xl font-bold mb-2">{plan.price}</div>
            <div className="font-semibold mb-4">{plan.name}</div>
            <ul className="text-left mb-6 space-y-2">
              {plan.features.map((f) => (
                <li key={f} className="flex items-center gap-2">
                  <span className="text-green-400">✓</span> <span>{f}</span>
                </li>
              ))}
            </ul>
            <button className={`w-full py-2 rounded-full font-semibold ${plan.highlight ? 'bg-white text-blue-600 hover:text-white hover:bg-blue-400' : 'bg-blue-600 text-white hover:bg-blue-700'} transition`}>Get started</button>
          </div>
        ))}
      </div>
    </section>
  );
} 